import React from "react";
import { Box, Tooltip } from "@mui/material";

const BlinkingDot = ({ 
  color = "#f97316", 
  size = 16, 
  dotSize = 6,
  tooltip = "",
  sx = {} 
}) => {
  // Convert hex color to RGB for the pulse effect
  const hexToRgb = (hex) => {
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result
      ? `${parseInt(result[1], 16)}, ${parseInt(result[2], 16)}, ${parseInt(result[3], 16)}`
      : "249, 115, 22"; 
  };

  const rgbColor = hexToRgb(color);

  const dotComponent = (
    <Box
      component="span"
      sx={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        width: size,
        height: size,
        verticalAlign: "middle",
        position: "relative",
        flexShrink: 0,
        ml: 1,
        ...sx,
      }}
    >
      {/* Radial pulse background */}
      <Box
        sx={{
          position: "absolute",
          width: "100%",
          height: "100%",
          borderRadius: "50%",
          background: `radial-gradient(circle, rgba(${rgbColor}, 0.6) 0%, rgba(${rgbColor}, 0.3) 40%, rgba(${rgbColor}, 0.1) 70%, rgba(${rgbColor}, 0) 100%)`,
          animation: "radialPulse 2s ease-out infinite",
          "@keyframes radialPulse": {
            "0%": {
              transform: "scale(0.5)",
              opacity: 1,
            },
            "50%": {
              transform: "scale(1.2)",
              opacity: 0.7,
            },
            "100%": {
              transform: "scale(1.5)",
              opacity: 0,
            },
          },
        }}
      />

      {/* Center dot */}
      <Box
        sx={{
          width: dotSize,
          height: dotSize,
          borderRadius: "50%",
          backgroundColor: color,
          position: "relative",
          zIndex: 1,
        }}
      />
    </Box>
  );

  if (tooltip) {
    return (
      <Tooltip title={tooltip} arrow>
        {dotComponent}
      </Tooltip>
    );
  }

  return dotComponent;
};

export default BlinkingDot;
